import {HoverPosition} from 'ui-library/drag-and-drop/hooks/useDnDCanvasDragState';
import moveSourceAdjacentToTarget from 'ui-library/drag-and-drop/move-item-handlers/moveSourceAdjacentToTarget';

import {GraphQLLayoutRowSpec} from './__generated/GraphQLLayoutRowSpec';

type AnalyticsQuery = GraphQLLayoutRowSpec['analyticsQueries'][number];

/**
 * Function that adapts layouts made with GraphQLLayoutRowSpec to move-item-handlers. Specifically it adapts
 * moveSourceAdjacentToTarget, which is the handler used by Insights.
 */
export default function moveBlockLayoutPosition(
  layoutRows: Array<GraphQLLayoutRowSpec>,
  sourceAnalyticsQuery: AnalyticsQuery,
  targetAnalyticsQuery: AnalyticsQuery,
  hoverPosition?: HoverPosition
): {newLayoutRows: Array<GraphQLLayoutRowSpec>; layoutChanged: boolean} {
  const oldLayout = layoutRows.map((row) => row.analyticsQueries);

  const {layoutChanged, newLayout} = moveSourceAdjacentToTarget(
    oldLayout,
    sourceAnalyticsQuery,
    targetAnalyticsQuery,
    hoverPosition,
    (query1: AnalyticsQuery, query2: AnalyticsQuery) => query1.id === query2.id
  );

  return {
    newLayoutRows: newLayout.map((row) => ({
      __typename: 'AnalyticsDashboardLayoutRowNode',
      analyticsQueries: row,
    })),
    layoutChanged,
  };
}
